export const defaultThumbnailOnError = (event: Event, defaultThumbnail: string): void => {
  if (event.target instanceof HTMLImageElement) {
    event.target.src = defaultThumbnail;
  }
};
